module.exports = __webpack_public_path__ + "static/media/slider-bg.12ba1cf9.png";